/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
// import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import useLanguage from "../common_hooks/useLanguage";
import ConditionalStatementInput from "../common_field/ConditionalStatementInput";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
// import dict from "../../Data/dict.json";

/*CONST*/

const SET_CS = ({
  //variable
  auth,
  layer,
  properties,

  //function
  set_value_properties,
}) => {
  //localStorage
  const { language } = useLanguage();

  //state & ref

  //global props
  const { field_editable } = properties;
  const { conditional_statement_list } = field_editable || {};
  const { geo_layer_list, layer_id } = layer;

  //variables
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;

  // filter fields based on parent_uuid (supaya cuma nampilin field di level yg sama)
  const fields = geo_layer?.fields.filter((field) => {
    if (field_editable?.parent_uuid) {
      return field?.parent_uuid === field_editable?.parent_uuid
    } else {
      return !field?.parent_uuid
    }
  }) || [];

  //functions
  const handleConditionalStatementList = (value) => {
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        conditional_statement_list: value,
      },
    });
  };

  // console.log("field_editable=", field_editable);
  // console.log("fields=", fields);

  return (
    <main>
      <h1 className="text_bold margin_bottom">
        Pengaturan Conditional Statement
      </h1>

      <div className="container background_grey_light outline_grey paddingTop_10 marginBottom_15">
        <ConditionalStatementInput
          language={language}
          fields={fields}
          handleConditionalStatementList={
            handleConditionalStatementList
          }
          conditional_statement_list={conditional_statement_list}
        />
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_CS);
